<template>
  <div class="sky-step-component">
    <component
      :data="data"
      :name="viewComponent"
      :is="viewComponent == 'SkyStepViewDefault' ? name : viewComponent"
      @handelToAutoNext="handelToAutoNext"
      @changeProjectId="changeProjectId"
      @showBtns="showBtns"
    ></component>
  </div>
</template>

<script>
import {} from 'element-ui'
//扫描组件包，动态挂载到components
const components = require.context('./metadata/caseDesign', true, /\.vue$/)
let obj = {}
components.keys().forEach(ele => {
  let fileName = components(ele).default.name
  obj[fileName] = components(ele).default
})

const order = require.context('./metadata/caseReport', true, /\.vue$/)
order.keys().forEach(ele => {
  let fileName = order(ele).default.name
  obj[fileName] = order(ele).default
})

export default {
  name: 'SkyStepComponent',
  props: {
    name: String,
    viewComponent: String,
    data: Object,
    customData: Object,
    formInfo: Object
  },
  components: obj,
  created() {},
  methods: {
    handelToAutoNext() {
      this.$emit('handelToAutoNext')
    },
    changeProjectId(param) {
      this.$emit('changeProjectId', param)
    },
    showBtns(param) {
      this.$emit('showBtns', param)
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(step-component) {
  position: relative;
  height: 100%;
}
</style>
